import React from 'react'
import { Link } from 'react-router-dom'
import { Button } from 'reactstrap'

const StiTestingChicago = () => {
  return (
    <div id='website-responsive'>
        <div className='bg-img py-md-5 py-4' style={{ backgroundImage:"url('sti-testing/Toxicology-Testing-Middle-bg-v1.webp')",backgroundPosition:'top', height:'100%', width:'100%'}}>
            <div className='pt-md-0 pt-4'>
                <div className='fs-ss-30-2 text-montserrat text-white fw-700 lh-1-2 pb-2'>
                    <center>
                        STI / STD Testing in Chicago
                    </center>
                </div>
                <div className='flex-center'>
                    <hr className='hr-style my-md-2' style={{ width:'80px', marginTop:'2px', marginBottom:'4px'}}/>
                </div>
            </div>

            <div className='pt-3'>
                <div className='fs-ss-20-2 text-montserrat text-white fw-600 lh-1-2 pb-2'>
                    <center>
                        Test results in less than 24 hours.<a href='tel:8004421663' className='fw-700 text-white' style={{ textDecoration:'none'}}> Call us </a>or schedule online today.
                    </center>
                </div>
            </div>

            <div className='pt-md-5 pt-4 flex-center'>
            <Link to='/sti-std-test-appointment'>
                     <Button className='btn-ss-secondary rounded30 ' style={{  boxShadow:'1px 1px 6px 0 rgba(0,0,0,.4)'}}>
                        <text className='text-montserrat fw-600 fs-ss-18' style={{ padding:'10px 1  px',}}>
                           Book Appointment
                        </text>
                    </Button>
                </Link>
                    </div>
        </div>
    </div>
  )
}

export default StiTestingChicago